module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_jordan_04.1dfe2f71.jpg";